<template>
  <div class="content">
    <div class="row">
      알림 전송 대상
      <ArtistSelect
        class="col-md-4"
        @unitChangeEvent="getArtistInfo"
        :initial-unit-id="0"
        :include-unit-artist="false"
        :show-all-units="true"
        :show-members="false"
        :is-multiple="true"
      />
      <div class="col-md-4">
        <h4 class="card-title text-left">예약전송시간</h4>
        <el-date-picker type="datetime" placeholder="예약전송시간" v-model="notificationTime">ㅇㅇ</el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">알림전송예상유저수 : {{ notifiableUserCount }}</div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <base-input placeholder="검색단어" v-model="searchKeyword">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <div class="col-md-2">
        <base-button @click="getNotices(1)" type="default">검색</base-button>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-2 text-right">
        <base-button @click="goForm" type="success">등록</base-button>
      </div>
    </div>
    <div class="row">
      <el-table :data="data" @row-click="rowClicked">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="50" align="right" label="알림보내기(푸시O)">
          <div v-if="props.row.isVisible === '노출'" slot-scope="props">
            <base-button @click.native.stop="sendNotification(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-send" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="알림보내기(푸시X)">
          <div v-if="props.row.isVisible === '노출'" slot-scope="props">
            <base-button @click.native.stop="sendNotificationWithoutPush(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-send" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="right" label="알림예약">
          <div v-if="props.row.isVisible === '노출'" slot-scope="props">
            <base-button @click.native.stop="sendReserveNotification(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-send" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, DatePicker } from "element-ui";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { URLUtils } from "@/util/URLUtils";
import { BaseInput, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import { Alert } from "@/util/Alert";
import moment from "moment-timezone";
import { BlipNamespace } from "@/common/BlipNamespace";

export default {
  components: {
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    BasePagination,
    ArtistSelect,
  },
  async created() {
    await this.getNotices();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "category",
          label: "카테고리",
          minWidth: 50,
        },
        {
          prop: "title",
          label: "제목",
          minWidth: 150,
        },
        {
          prop: "isVisible",
          label: "노출여부",
          minWidth: 50,
        },
        {
          prop: "regTime",
          label: "작성일",
          minWidth: 50,
        },
      ],
      data: [],
      currentPage: 1,
      totalPages: null,
      unitId: null,
      notifiableUserCount: null,
      notificationTime: null,
      searchKeyword: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getNotices(this.currentPage);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.unitName = param.unitName;
      await this.getNotifiableUserCount(this.unitId);
    },
    async getNotifiableUserCount(unitId) {
      if (!unitId || unitId.includes(null)) {
        this.notifiableUserCount = null;
        return;
      }
      return this.$axios.get(`/notification/count?unitIds=${unitId.toString()}`).then((res) => {
        this.notifiableUserCount = res.data.data.count;
      });
    },
    async getNotices(page) {
      const params = {};
      params.currentPage = page ? page : 1;
      params.searchKeyword = this.searchKeyword;
      return this.$axios.get("/notice", { params }).then((res) => {
        this.data = res.data.data.data;
        this.data = this.data.map((item) => {
          item.isVisible = item.isVisible === 1 ? "노출" : "비노출";
          item.regTime = formatDateTime(item.regTime);
          return item;
        });
        this.totalPages = Number(res.data.data.page);
      });
    },
    async sendNotificationWithoutPush(prop) {
      if (
        await Alert.dangerousConfirmCancel(
          "알림",
          `알림을 전송하시겠습니까? <br>-제목: ${prop.title} <br>-대상: ${this.unitId.includes(null) ? "전체" : this.unitName} <br>-푸시: X`,
          "전송",
          "취소"
        )
      ) {
        try {
          await this.$axios.post(`/notice/${prop.id}/notificationWithoutPush`, { unitIds: this.unitId.includes(null) ? null : this.unitId });
          window.Toast.success(`알림이 전송되었습니다`);
        } catch (err) {
          window.Toast.error("알림이 전송 중 에러가 발생하였습니다.");
        }
      }
    },
    async sendNotification(prop) {
      if (
        await Alert.dangerousConfirmCancel(
          "푸시알림",
          `알림을 전송하시겠습니까? <br>-제목: ${prop.title} <br>-대상: ${this.unitId.includes(null) ? "전체" : this.unitName} <br>-푸시: O`,
          "전송",
          "취소"
        )
      ) {
        try {
          await this.$axios.post(`/notice/${prop.id}/notification`, { unitIds: this.unitId.includes(null) ? null : this.unitId });
          window.Toast.success(`푸시알림이 전송되었습니다`);
        } catch (err) {
          const msg = err?.response?.data?.error?.message || err?.response?.data?.message || err?.message || "푸시알림 전송 중 알 수 없는 오류가 발생했습니다.";
          alert(msg);
          window.Toast.error("푸시알림이 전송 중 에러가 발생하였습니다.");
        }
      }
    },
    async sendReserveNotification(prop) {
      if (!this.notificationTime) {
        window.Toast.error("예약 알림 시간이 없습니다");
        return;
      }
      if (this.notificationTime < moment()) {
        window.Toast.error("예약 시간이 현재 시간보다 빠릅니다");
        return;
      }
      if (
        await Alert.dangerousConfirmCancel(
          "푸시알림",
          `알림을 예약하시겠습니까?<br>-제목: ${prop.title} <br>-대상: ${this.unitId.includes(null) ? "전체" : this.unitName} <br>-푸시: O <br>-예약전송시간: ${
            this.notificationTime
          }`,
          "예약",
          "취소"
        )
      ) {
        try {
          const metadata = { unitIds: this.unitId.includes(null) ? null : this.unitId };
          await this.$axios.post(`/notification/reserveNotification`, {
            contentId: prop.id,
            namespace: BlipNamespace.NOTICE,
            metadata: JSON.stringify(metadata),
            notificationTime: this.notificationTime,
          });
          window.Toast.success(`알림 예약이 되었습니다`);
        } catch (err) {
          window.Toast.error("예약 중 에러가 발생하였습니다.");
        }
      }
    },
    rowClicked(row) {
      this.$router.push(`/notices/noticeDetail?${URLUtils.objectToQueryString({ id: row.id })}`);
    },
    goForm() {
      this.$router.push(`/notices/noticeDetail`);
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
